'use client'

import { Redirect } from '@/components/pages/CMS/dynamic/Redirect'
import { useNavigation } from '@/core/hooks/useNavigation'
import { useParsedParam } from '@/core/hooks/useRouteParams'
import {
  CompetitionInfoRoute,
  CompetitionRoute,
  RootRoute
} from '@/core/route-keys'
import { useBrackets } from '@/entity/bracket/useBrackets'
import { useCompetitionParticipant } from '@/entity/competition/useCompetitionParticipant'
import { BracketState } from '@rallycry/api-suite-typescript'

const CompetitionOverviewPage = () => {
  const competitionId = useParsedParam('competitionId')
  const { brackets } = useBrackets()
  const { hasTeam } = useCompetitionParticipant()
  const { getPath } = useNavigation()
  const active = brackets?.findLast(it => it.state === BracketState.STARTED)
  return (
    <Redirect
      replace
      path={
        active && hasTeam()
          ? getPath({
              root: RootRoute.Competition,
              rootId: competitionId,
              subRoute: CompetitionRoute.Bracket,
              subId: active.id
            })
          : getPath({
              root: RootRoute.Competition,
              rootId: competitionId,
              subRoute: CompetitionRoute.Info,
              subId: CompetitionInfoRoute.Details
            })
      }
    />
  )
}

export default CompetitionOverviewPage
